import axiosInstance from './axiosInstance';

const activityService = {
    // Get recent activities for an agent
    async getAgentActivities(agentId, limit = 10) {
        try {
            const response = await axiosInstance.get(`/activities/agent/${agentId}`, {
                params: { limit }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching agent activities:', error);
            throw error.response?.data || error.message;
        }
    },

    // Get all activities for an agent
    async getAllAgentActivities(agentId, page = 1, limit = 20) {
        try {
            const response = await axiosInstance.get(`/activities/agent/${agentId}/all`, {
                params: { page, limit }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching all agent activities:', error);
            throw error.response?.data || error.message;
        }
    },

    // Get pending tasks for an agent
    async getAgentTasks(agentId) {
        try {
            const response = await axiosInstance.get(`/tasks/agent/${agentId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching agent tasks:', error);
            throw error.response?.data || error.message;
        }
    },

    // Update task status
    async updateTaskStatus(taskId, status) {
        try {
            const response = await axiosInstance.patch(`/tasks/${taskId}/status`, { status });
            return response.data;
        } catch (error) {
            console.error('Error updating task status:', error);
            throw error.response?.data || error.message;
        }
    }
};

export default activityService; 